import type { ServerMessage } from "../shared/types";
import { BingoBoardView } from "./board-view";
import { BingoSocket } from "./socket";

export function renderOverlayPage(app: HTMLElement, boardId: string): void {
  document.body.className = "overlay-body";
  document.title = "Bingo-overlay";
  const board = new BingoBoardView();
  app.className = "overlay-app";
  app.replaceChildren(board.element);

  const socket = new BingoSocket({
    boardId,
    mode: "overlay",
    onStatus: () => undefined,
    onMessage: (message: ServerMessage) => {
      if (message.type === "state") board.render(message.state, message.reason, message.change);
    },
  });
  socket.start();
  window.addEventListener("pagehide", () => {
    socket.stop();
    board.destroy();
  });
}
